import actionTypes from 'constants/actionTypes'
import defaultsDeep from 'lodash/defaultsDeep'

interface BookmarkMetaState {
  isFetching: boolean
  failed: boolean
}

interface BookmarkMetaAction {
  type?: string
}

const initialState: BookmarkMetaState = {
  isFetching: false,
  failed: true,
}

const meta = (state: BookmarkMetaState = initialState, action: BookmarkMetaAction): BookmarkMetaState => {
  switch (action.type) {
    case actionTypes.BOOKMARKS.MULTI.GET_ALL.REQUEST:
      return defaultsDeep(
        {
          isFetching: true,
          failed: false
        },
        state
      )
    case actionTypes.BOOKMARKS.MULTI.GET_ALL.RECEIVE:
      return defaultsDeep(
        {
          isFetching: false,
          failed: false
        },
        state
      )
    case actionTypes.BOOKMARKS.MULTI.GET_ALL.FAIL:
      return defaultsDeep(
        {
          isFetching: false,
          failed: true
        },
        state
      )
    default:
      return state
  }
}

export default meta
